<template>
  <div :style="{ width, height }" class="icon">
    <svg
      v-if="name === 'plane'"
      viewBox="0 0 13 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path fill="#292929" d="M12.4894167,5.82231233 L9.8111477,5.82231233 L7.10434305,9.75141887 C6.86382879,10.1292915 6.39248197,10.3895752 5.84138837,10.4487539 L5.82049624,10.4502911 L3.81918313,10.5625 L5.69794606,5.82231233 L0.510583255,5.82231233 C0.228794293,5.82231233 0,5.59251455 0,5.30891796 C0,5.02557755 0.228794293,4.79552359 0.510583255,4.79552359 L5.71985732,4.79552359 L3.81918313,0 L5.84138837,0.114002244 C6.39248197,0.172668567 6.86382879,0.433208525 7.10434305,0.81108113 L9.849365,4.79552359 L12.4894167,4.79552359 C12.7714605,4.79552359 13,5.02557755 13,5.30891796 C13,5.59251455 12.7714605,5.82231233 12.4894167,5.82231233" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 16
    }
  },
  computed: {
    height () {
      return this.size + 'px'
    },
    width () {
      return this.size + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
